import styled from 'styled-components'
import { Button } from 'reactstrap'

export const StyledExportButton = styled(Button)`
  borderRadius: 0.125rem;   
  margin: 0.3125rem;
`




// WEBPACK FOOTER //
// ./src/containers/css-admin/users/styles.js